import axios from "~/plugins/axios";
import store from "@/store";
export default {
  data() {
    return {
      deviceToken: null
    };
  },
  openExternal(link) {
    if (window.cordova && link.href.indexOf("http") > -1) {
      //if app open on _system browser
      window.cordova.InAppBrowser.open(
        link.href,
        "_system",
        "location=no,toolbar=no,zoom=no,hardwareback=no,enableViewportScale=yes"
      );
    } else {
      window.open(link.href, "blank");
    }
  },
  isJsonString(value) {
    if (typeof value !== "string") return false;
    try {
      const parsed = JSON.parse(value);
      return typeof parsed === "object" && parsed !== null;
    } catch (e) {
      return false;
    }
  },
  resolveLink(link, payload) {
    //utilizzare stessa tecnica della page per capire se è un link interno o no....
    if (global.config.domainWhitelist.includes(link.hostname)) {
      let resolved = global.vm.$router.resolve({
        path: link.pathname
      });
      if (
        resolved &&
        resolved.route.matched.length > 0 &&
        resolved.route.name != "DefaultRoute"
      ) {
        if (typeof payload !== "string")
          global.EventBus.$emit("pushNotificationTapped", payload);
        global.vm.$router.push(resolved.route).then(() => {});
      } else {
        if (typeof payload !== "string")
          global.EventBus.$emit("pushNotificationTapped", payload);
        this.openExternal(link);
      }
    } else {
      if (typeof payload !== "string")
        global.EventBus.$emit("pushNotificationTapped", payload);
      this.openExternal(link);
    }
  },
  handlePush(notification) {
    // console.log("::: HANDLEPUSH FIREBASE ::::: ", notification);
    // console.log("Message type: " + notification.messageType);
    // console.log("Tapped in " + notification.tap);
    if (notification) {
      let isJsonString = false;
      if (notification.aps && notification.aps.alert) {
        //iOS - NAV TO
        if (notification && notification.tap === "background") {
          if (notification.payload) {
            if (this.isJsonString(notification.payload)) {
              notification.payload = JSON.parse(notification.payload);
            }
            let navTo = notification.payload.nav_to
              ? notification.payload.nav_to
              : null;
            if (navTo && this.isJsonString(navTo)) {
              navTo = JSON.parse(navTo);
              isJsonString = true;
            }
            let link = new URL(
              isJsonString ? navTo.nav_to : navTo,
              window.location.href
            );
            this.resolveLink(link, notification.payload);
          } else if (notification.nav_to) {
            let navTo = notification.nav_to;
            if (this.isJsonString(navTo)) {
              navTo = JSON.parse(navTo);
              isJsonString = true;
            }
            let link = new URL(
              isJsonString ? navTo.nav_to : navTo,
              window.location.href
            );
            this.resolveLink(link, navTo);
          }
        } else {
          global.EventBus.$emit("notification", {
            title: notification.aps.alert.title,
            message: notification.body,
            callback: value => {
              if (value) {
                if (notification.payload) {
                  if (this.isJsonString(notification.payload)) {
                    notification.payload = JSON.parse(notification.payload);
                  }
                  let navTo = notification.payload.nav_to
                    ? notification.payload.nav_to
                    : null;
                  if (navTo && this.isJsonString(navTo)) {
                    navTo = JSON.parse(navTo);
                    isJsonString = true;
                  }
                  let link = new URL(
                    isJsonString ? navTo.nav_to : navTo,
                    window.location.href
                  );
                  this.resolveLink(link, notification.payload);
                } else if (notification.nav_to) {
                  let navTo = notification.nav_to;
                  if (this.isJsonString(navTo)) {
                    navTo = JSON.parse(navTo);
                    isJsonString = true;
                  }
                  let link = new URL(
                    isJsonString ? navTo.nav_to : navTo,
                    window.location.href
                  );
                  this.resolveLink(link, navTo);
                }
              }
            }
          });
        }
      } else if (notification.title) {
        // ANDROID
        if (notification && notification.tap === "background") {
          if (notification.payload) {
            if (this.isJsonString(notification.payload)) {
              notification.payload = JSON.parse(notification.payload);
            }
            let navTo = notification.payload.nav_to
              ? notification.payload.nav_to
              : null;
            if (navTo && this.isJsonString(navTo)) {
              navTo = JSON.parse(navTo);
              isJsonString = true;
            }
            let link = new URL(
              isJsonString ? navTo.nav_to : navTo,
              window.location.href
            );
            this.resolveLink(link, notification.payload);
          } else if (notification.nav_to) {
            let navTo = notification.nav_to;
            if (this.isJsonString(navTo)) {
              navTo = JSON.parse(navTo);
              isJsonString = true;
            }
            let link = new URL(
              isJsonString ? navTo.nav_to : navTo,
              window.location.href
            );
            this.resolveLink(link, navTo);
          }
        } else {
          global.EventBus.$emit("notification", {
            title: notification.title,
            message: notification.body,
            callback: value => {
              if (value) {
                if (notification.payload) {
                  if (this.isJsonString(notification.payload)) {
                    notification.payload = JSON.parse(notification.payload);
                  }
                  let navTo = notification.payload.nav_to
                    ? notification.payload.nav_to
                    : null;
                  if (navTo && this.isJsonString(navTo)) {
                    navTo = JSON.parse(navTo);
                    isJsonString = true;
                  }
                  let link = new URL(
                    isJsonString ? navTo.nav_to : navTo,
                    window.location.href
                  );
                  this.resolveLink(link, notification.payload);
                } else if (notification.nav_to) {
                  let navTo = notification.nav_to;
                  if (this.isJsonString(navTo)) {
                    navTo = JSON.parse(navTo);
                    isJsonString = true;
                  }
                  let link = new URL(
                    isJsonString ? navTo.nav_to : navTo,
                    window.location.href
                  );
                  this.resolveLink(link, navTo);
                }
              }
            }
          });
        }
      }
    }
  },
  async unRegisterFirebaseDevice() {
    console.log("::: FIREBASE ::::: UNREGISTER FIREBASE START");
    if (window.FirebasePlugin) {
      window.FirebasePlugin.unregister();
      // eslint-disable-next-line no-undef
      this.unRegister(device);
    }
  },
  async registerFirebaseDevice() {
    let _this = this;
    console.log("::: FIREBASE ::::: REGISTER FIREBASE START");
    if (window.FirebasePlugin) {
      window.FirebasePlugin.grantPermission(
        function() {
          console.log("::: FIREBASE ::::: Push granted");
        },
        function() {
          console.log("::: FIREBASE ::::: Push not granted");
        }
      );
      window.FirebasePlugin.onMessageReceived(notification => {
        this.handlePush(notification);
      });
      window.FirebasePlugin.getToken(
        function(token) {
          // eslint-disable-next-line no-undef
          _this.register(token, device);
          _this.deviceToken = token;
          window.FirebasePlugin.subscribe("all");
        },
        function(error) {
          console.error("::::: ERROR GET TOKEN :::: ", error);
        }
      );

      window.FirebasePlugin.onTokenRefresh(
        function(token) {
          if (store && store.getters["cart/isAuthenticated"] == true) {
            // eslint-disable-next-line no-undef
            _this.register(token, device);
            _this.deviceToken = token;
          }
        },
        function(error) {
          console.error("::: ERROR FIREBASE :::::", error);
        }
      );
    }
  },
  register(externalId, device) {
    console.log("::: SERVICE REGISTER ::::: ", { externalId, device });
    return axios
      .get("/ebsn/api/externalregistration/register", {
        params: {
          external_id: externalId,
          model: device.model,
          platform: device.platform,
          platform_version: device.version,
          manufacturer: device.manufacturer,
          uuid: device.uuid
        }
      })
      .then(data => {
        return data;
      });
  },
  unRegister(device) {
    console.log("::: SERVICE UNREGISTER ::::: ", device);
    return axios
      .get("/ebsn/api/externalregistration/unregister", {
        params: {
          platform: device.platform,
          uuid: device.uuid
        }
      })
      .then(data => {
        return data;
      });
  }
};
